import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown, FaChevronUp, FaQuestionCircle } from "react-icons/fa";
import Navbar from "../components/Navbar"; // ✅ Import your existing Navbar component

const faqs = [
  {
    question: "What types of LED lights do you offer?",
    answer:
      "We offer a wide range of LED products including bulbs, ceiling lights, tube lights, floodlights, and decorative lighting for homes and offices.",
  },
  {
    question: "Do your LED lights come with a warranty?",
    answer:
      "Yes! All our LED lights come with a 6-month limited warranty covering manufacturing defects. Please keep your purchase receipt for warranty claims.",
  },
  {
    question: "How long do LED lights last?",
    answer:
      "Our LED products are designed to last up to 25,000–50,000 hours depending on usage and environment conditions.",
  },
  {
    question: "Do you offer delivery across Pakistan?",
    answer:
      "Yes, we deliver all over Pakistan through trusted courier services. Delivery times vary by city.",
  },
  {
    question: "How can I contact customer support?",
    answer:
      "You can reach us anytime via WhatsApp or our contact page for any inquiries, returns, or technical support.",
  },
];

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-[#542757]/10 to-[#9b1f6c]/10 flex flex-col items-center pt-28 px-4 pb-12">
        {/* Header */}
        <motion.h1
          className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#542757] to-[#9b1f6c] mb-10 text-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Frequently Asked Questions
        </motion.h1>

        {/* FAQ List */}
        <div className="w-full max-w-3xl bg-white rounded-2xl shadow-xl p-6 md:p-10">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-200 py-4">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex justify-between items-center text-left focus:outline-none"
              >
                <div className="flex items-center space-x-3">
                  <FaQuestionCircle className="text-[#542757] text-xl" />
                  <span className="text-lg font-semibold text-gray-800">
                    {faq.question}
                  </span>
                </div>
                {openIndex === index ? (
                  <FaChevronUp className="text-[#542757]" />
                ) : (
                  <FaChevronDown className="text-gray-500" />
                )}
              </button>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="mt-3 text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Faqs;
